import {Component} from "react";
import React from "react";
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";
//comp
import PopUp from "./Forms/PopUp";
import CreateGroupForm from "./Forms/CreateGroupForm";
//other
import {isAdmin} from "../../helpers";
import {destroy as destroyStation, put as putStation, getGroupTypes} from "../../actions/stations";
import {destroy as destroyWheelChanger, put as putWheelChanger} from "../../actions/wheelChangers";
import Config from "../../config";


class GroupActions extends Component {

    static propTypes = {
        /** group data */
        group: PropTypes.object
    };

    constructor(props) {

        super(props);
        this.state = {
            editGroupId: null,
            deleteGroupId: null
        }
    }

    editGroup(e) {

        e.preventDefault();
        e.stopPropagation();
        if (typeof (this.props.groupTypes) === "undefined" || this.props.groupTypes.length === 0) {
            this.props.getGroupTypes();
        }

        if (typeof (this.props.groups) === "undefined" && this.props.groups.length === 0) {
            this.props.getGroups();
        }

        let value = e.target.getAttribute("value");
        this.setState({editGroupId: value});
    }

    editCancel(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({editGroupId: null});
    }

    editAccept() {
        this.setState({editGroupId: null});
    }


    deleteGroup(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            deleteGroupId: e.target.getAttribute("value")
        });
    }

    deleteGroupAccept(e) {
        const {group} = this.props;
        let deleteGroupId = this.state.deleteGroupId;
        this.setState({
            deleteGroupId: null,
            active: false
        });

        //delete by type
        if (group.type === Config.STATION_TYPES.NONE ||
            group.type === Config.STATION_TYPES.PORT ||
            group.type === Config.STATION_TYPES.STATION ||
            group.type === Config.STATION_TYPES.RECYCLE) {
            this.props.destroyStation(deleteGroupId);
        } else {
            this.props.destroyWheelChanger(deleteGroupId);
        }

    }

    deleteGroupCancel(e) {
        this.setState({
            deleteGroupId: null
        })
    }


    onClick(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    render() {
        const {group} = this.props;
        const {editGroupId, deleteGroupId} = this.state;

        const hasUsers = group.users && group.users.length > 0;
        const hasWheelChangers = group.wheelChangers && group.wheelChangers.length > 0;
        const hasWheels = group.hasWheels;
        const canBeDeleted = !hasUsers && !hasWheelChangers && !hasWheels;


        return (
            <div className="userActionsWrapper" onClick={(e) => this.onClick(e)}>
                {isAdmin() &&
                <div className="userActions">
                    <ul>
                        <li value={group.id}>
                            <a className="icon edit"
                               onClick={(e) => this.editGroup(e)}
                               value={group.id} href={"#redigera"}>
                                Redigera

                            </a>
                        </li>
                        {canBeDeleted &&
                        <li value={group.id}>
                            <a className="icon delete"
                               onClick={(e) => this.deleteGroup(e)}
                               value={group.id}
                               href={"#delete-group"}>
                                Ta bort
                            </a>
                        </li>
                        }
                    </ul>
                </div>
                }

                {isAdmin() && editGroupId &&
                <PopUp
                    onAccept={(e) => this.editSave(e)}
                    onCancel={(e) => this.editCancel(e)}
                    acceptButtonText={"Uppdatera"}
                    cancelButtonText={"Annullera"}
                    title={null}
                    showButtons={false}
                >
                    <CreateGroupForm
                        title={"Redigera \"" + group.name + "\""}
                        group={group}
                        groups={this.props.groups}
                        groupTypes={this.props.groupTypes}
                        onCancel={(e) => this.editCancel(e)}
                        onAccept={() => this.editAccept()}
                    />
                </PopUp>
                }

                {deleteGroupId &&
                <PopUp
                    onAccept={(e) => this.deleteGroupAccept(e)}
                    onCancel={(e) => this.deleteGroupCancel(e)}
                    title={"Ta bort \"" + group.name + "\", är du säker?"}
                />
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        groups: state.stations.groups,
        groupTypes: state.stations.groupTypes,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        putStation: (station) => dispatch(putStation(station)),
        putWheelChanger: (wheelChanger) => dispatch(putWheelChanger(wheelChanger)),
        getGroupTypes: () => dispatch(getGroupTypes()),
        destroyStation: (id) => dispatch(destroyStation(id)),
        destroyWheelChanger: (id) => dispatch(destroyWheelChanger(id)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupActions)



// WEBPACK FOOTER //
// ./src/components/UI_Elements/GroupActions.js